// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"d9c74246ea437f3183e4","293":"30ec55fc2a74cb15725d","518":"630ca6245bf43cee6c95","779":"66101abd8d0d4be43fb9"}[chunkId] + ".js";
};